import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import { Title } from "./GlobalMassssage";
import Footer from "./Footer";

const Layout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate()
  let title = "JobMongo";

  // Check if the current route is "/login" or "/logout"
  const isLoginPage =
    location.pathname === "/login" || location.pathname === "/logout";

  // Set dynamic page title
  switch (location.pathname) {
    case "/":
      title = "Dashboard | " + Title;
      break;
    case "/login":
      title = "Login | " + Title;
      break;
    case "/client":
      title = "Client | " + Title;
      break;
    case "/job":
      title = "Job | " + Title;
      break;
    case "/staff":
      title = "Users | " + Title;
      break;
    case "/Setting":
    case "/setting":
      title = "Setting | " + Title;
      break;
  }
  document.title = title;

  useEffect(() => {
    const allowedPaths = ["/service-job-type", "/setting", "/addupdateChecklist", "/job", "/viewClient"];

    if (
      location.pathname !== localStorage.getItem("CurrentPath") &&
      !allowedPaths.includes(location.pathname)
    ) {
      Object.keys(localStorage).forEach((key) => {
        if (key.startsWith("selectedTab_")) {
          localStorage.removeItem(key);
        }
      });
      localStorage.removeItem("CurrentPath");

    }

  }, [location.pathname]);


  useEffect(() => {
    const storedAuth = JSON.parse(localStorage.getItem("login"));
    if (!storedAuth) {
      navigate("/login")
    }
  }, []);

  return (
    <div className="min-h-screen bg-white-100 flex flex-col">
      {/* Render Navbar only if not on login page */}
      {!isLoginPage && <Navbar />}

      <main
        className={`flex-grow mx-auto px-1 py-1 w-full ${isLoginPage ? "flex items-center justify-center" : ""
          }`}
      >
        {children}
      </main>

      {/* Render Footer only if not on login page */}
      {!isLoginPage && <Footer />}
    </div>
  );
};

export default Layout;
